import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

// Pages Components
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { useSelector, useDispatch } from "react-redux";

import {
  getProjectsNew as onGetProjectsNew,
  getRecipes as onGetRecipes,
  getRecipesReview as onGetRecipesReview,
  getUsers as onGetUsers,
  getNews as onGetNews,
  getSlider as onGetSlider,
} from "store/contacts/actions";

const IMG_BASE = "https://buharasubdomain.stechomeyazilim.info/";

// Günün saatine göre selamlama
const greeting = () => {
  const h = new Date().getHours();
  if (h < 6) return "İyi geceler";
  if (h < 12) return "Günaydın";
  if (h < 18) return "İyi günler";
  return "İyi akşamlar";
};

const StatCard = ({ title, count, icon, color, link }) => (
  <Link to={link} className="bh-stat">
    <div className="bh-stat__top">
      <span
        className="bh-stat__icon"
        style={{ backgroundColor: color + "1A", color }}
      >
        <i className={"bx " + icon} />
      </span>
      <span className="bh-stat__go">
        Görüntüle <i className="bx bx-right-arrow-alt" />
      </span>
    </div>
    <p className="bh-stat__label">{title}</p>
    <p className="bh-stat__value">{count}</p>
  </Link>
);

StatCard.propTypes = {
  title: PropTypes.string,
  count: PropTypes.any,
  icon: PropTypes.string,
  color: PropTypes.string,
  link: PropTypes.string,
};

// Son eklenenler listesi (ürün / tarif ortak)
const RecentList = ({ title, items, link, image, label, emptyText }) => (
  <Card className="h-100">
    <CardBody>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="card-title mb-0">{title}</h5>
        <Link to={link} className="btn btn-sm btn-outline-primary">
          Tümünü Gör
        </Link>
      </div>

      {items.length > 0 ? (
        <ul className="bh-list">
          {items.map(item => {
            const name = label(item) || "-";
            const img = image(item);
            return (
              <li key={item.ID}>
                <Link to={link}>
                  {img ? (
                    <img className="bh-list__thumb" src={IMG_BASE + img} alt="" />
                  ) : (
                    <span className="bh-list__ph">{name.charAt(0)}</span>
                  )}
                  <span className="bh-list__name">{name}</span>
                  <span className="bh-list__meta">#{item.ID}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="bh-empty mb-0">{emptyText}</p>
      )}
    </CardBody>
  </Card>
);

RecentList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  link: PropTypes.string,
  image: PropTypes.func,
  label: PropTypes.func,
  emptyText: PropTypes.string,
};

const Dashboard = props => {
  const dispatch = useDispatch();

  const { projects, recipesR, recipesReview, users, news, slider } = useSelector(
    state => ({
      projects: state.contacts.projects || [],
      recipesR: state.contacts.recipesR || [],
      recipesReview: state.contacts.recipesReview || [],
      users: state.contacts.users || [],
      news: state.contacts.news || [],
      slider: state.contacts.slider || [],
    })
  );

  useEffect(() => {
    dispatch(onGetUsers());
    dispatch(onGetProjectsNew());
    dispatch(onGetRecipes());
    dispatch(onGetRecipesReview());
    dispatch(onGetNews());
    dispatch(onGetSlider());
  }, [dispatch]);

  //meta title
  document.title = "Anasayfa | Buhara Admin Paneli";

  const stats = [
    { title: "Ürünler", count: projects.length, icon: "bx-package", color: "#0a4022", link: "/projects" },
    { title: "Tarifler", count: recipesR.length, icon: "bx-book-content", color: "#d99a2b", link: "/recipes" },
    { title: "Blog Yazıları", count: news.length, icon: "bxl-blogger", color: "#c0392b", link: "/news" },
    { title: "Slider", count: slider.length, icon: "bx-slideshow", color: "#2980b9", link: "/slider" },
    { title: "Kullanıcılar", count: users.length, icon: "bx-user-pin", color: "#7c5cc4", link: "/usersList" },
    { title: "Tarif Yorumları", count: recipesReview.length, icon: "bx-star", color: "#16a085", link: "/productsReview" },
  ];

  const recentProjects = [...projects].reverse().slice(0, 5);
  const recentRecipes = [...recipesR].reverse().slice(0, 5);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Yönetim")}
            breadcrumbItem={props.t("Anasayfa")}
          />

          {/* Karşılama alanı + hızlı işlemler */}
          <div className="bh-hero">
            <p className="bh-hero__eyebrow">Buhara Baharat Yönetim Paneli</p>
            <h1 className="bh-hero__title">{greeting()}!</h1>
            <p className="bh-hero__text">
              Tarifleri, ürünleri ve site içeriğini buradan yönetebilirsiniz.
              Aşağıdaki kartlardan içerik sayısını görebilir, tek tıkla ilgili sayfaya geçebilirsiniz.
            </p>
            <div className="bh-hero__actions">
              <Link to="/recipes" className="bh-hero__btn bh-hero__btn--gold">
                <i className="bx bx-plus" /> Yeni Tarif
              </Link>
              <Link to="/projects" className="bh-hero__btn">
                <i className="bx bx-package" /> Ürünler
              </Link>
              <a
                href="https://buhara.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bh-hero__btn"
              >
                <i className="bx bx-globe" /> Siteyi Görüntüle
              </a>
            </div>
          </div>

          {/* İstatistik kartları */}
          <Row>
            {stats.map((stat, key) => (
              <Col xl="2" lg="4" md="6" key={"_stat_" + key} className="mb-4">
                <StatCard {...stat} />
              </Col>
            ))}
          </Row>

          {/* Son eklenenler */}
          <Row>
            <Col xl="6" className="mb-4">
              <RecentList
                title="Son Eklenen Ürünler"
                items={recentProjects}
                link="/projects"
                label={item => item.Products_Name}
                image={item => item.Products_Image}
                emptyText="Henüz ürün eklenmemiş."
              />
            </Col>
            <Col xl="6" className="mb-4">
              <RecentList
                title="Son Eklenen Tarifler"
                items={recentRecipes}
                link="/recipes"
                label={item => item.Recipes_Title}
                image={item => item.Recipes_Image}
                emptyText="Henüz tarif eklenmemiş."
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Dashboard);
